import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "xmove_admin_token";
const EVENT = "xmove-auth-change";

export const getToken = () => localStorage.getItem(KEY);
export const authHeaders = () => (getToken() ? { Authorization: `Bearer ${getToken()}` } : {});

const notifica = () => window.dispatchEvent(new Event(EVENT));

export const logout = () => {
  localStorage.removeItem(KEY);
  notifica();
};

export const login = async (password) => {
  const { data } = await axios.post(`${API}/auth/login`, { password });
  localStorage.setItem(KEY, data.token);
  notifica();
};

export const verificaSessione = () =>
  getToken() ? axios.get(`${API}/auth/me`).then(() => true).catch(() => false) : Promise.resolve(false);

export const onAuthChange = (cb) => {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
};

// Header Authorization automatico su tutte le chiamate al backend + logout su 401.
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token && config.url?.startsWith(API)) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axios.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && getToken() && !error.config?.url?.includes("/auth/login")) logout();
    return Promise.reject(error);
  }
);
